import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import {
	SHOP_CATEGOTY_SAVED,
	SHOP_CATEGOTY_SAVING,
	SHOP_CATEGOTY_SAVING_FAILED,
} from "./types";
export const shopSaveInputsAction = (listdata) => (dispatch) => {
	dispatch({ type: SHOP_CATEGOTY_SAVING });

	let formData = new FormData(); //formdata object
	console.log("ShopCategorySaveActions data=", listdata);

	var listItems = listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			dispatch({
				type: SHOP_CATEGOTY_SAVED,
				payload: response.data,
			});
			storeNotification.addNotification({
				title: "Shop input saving!",
				message: "Succefull saved",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("shopSaveCategory response=", response);
		})
		.catch((error) => {
			console.log("shopSaveCategory=", error);
			storeNotification.addNotification({
				title: "Shop input saving!",
				message: "Failure to save",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			dispatch({ type: SHOP_CATEGOTY_SAVING_FAILED });
		});
};
